<template>
  <div class="yxtbiz-practice__form font-size-16 color-gray-10">
    <template v-if="value.type === 5">
      <div>
        <div class="font-size-14 lh24" v-html="cleanStyle(value.content)" data-rich-text="1"></div>
        <media-player v-if="value.fileId && value.questionType > 1"
                    :key="value.id"
                    :type="value.questionType"
                    :options="playerOptions"
                    :tranStatus="value.tranStatus"></media-player>
      </div>
    </template>
    <template v-else>
      <div class="yxtbiz-practice__form-sub">
        {{ index + 1 }}.
      </div>
      <div class="yxtbiz-practice__form-content pl6">
        <div v-html="cleanStyle(value.content)" data-rich-text="1"></div>
        <media-player v-if="value.fileId && value.questionType > 1"
                      :key="value.id"
                      :type="value.questionType"
                      :options="playerOptions"
                      :tranStatus="value.tranStatus"></media-player>
        <div class="mt16">
          <template v-if="value.type === 0">
            <!-- 单选题 -->
            <yxtf-radio-group v-model="value.answer"
                              class="mfl12 color-primary-6 yxtbiz-practice__radio-group active mv-f8"
                              :direction="'row'"
                              :disabled="!!value.isAnswered ? 'lock': false"
                              @change="submitSingle()">
              <yxtf-radio v-for="(i, j) in value.choiceItems"
                          :key="i.id"
                          :label="i.id"
                          :class="{'hover-primary-6-i': !value.isAnswered}"
                          class="yxtbiz-practice__radio active">
                <span>{{ convertASCIIForNum(j) }}. </span><span v-html="cleanStyle(i.itemContent, true)" data-rich-text="1"></span>
                <media-player v-if="i.itemPlay && i.itemPlay.fileId"
                              :key="i.itemPlay.fileId"
                              :type="i.itemPlay.type"
                              :options="playerMediaOptions(i.itemPlay)"
                              :tranStatus="i.itemPlay.tranStatus"></media-player>
              </yxtf-radio>
            </yxtf-radio-group>
          </template>
          <template v-else-if="value.type === 1">
            <!-- 多选题 -->
            <yxtf-checkbox-group v-model="value.answers"
                                 :disabled="!!value.isAnswered ? 'lock': false"
                                 :direction="'row'"
                                 class="mfl12 mv-f8 color-primary-6 yxtbiz-practice__checkbox-group active"
                                 @change="submitSingle()">
              <yxtf-checkbox v-for="(i, j) in value.choiceItems"
                             :key="i.id"
                             :label="i.id"
                             :class="{'hover-primary-6-i': !value.isAnswered}"
                             class="yxtbiz-practice__checkbox active">
                <span>{{ convertASCIIForNum(j) }}. </span><span v-html="cleanStyle(i.itemContent, true)" data-rich-text="1"></span>
                <media-player v-if="i.itemPlay && i.itemPlay.fileId"
                              :key="i.itemPlay.fileId"
                              :type="i.itemPlay.type"
                              :options="playerMediaOptions(i.itemPlay)"
                              :tranStatus="i.itemPlay.tranStatus"></media-player>
              </yxtf-checkbox>
            </yxtf-checkbox-group>
          </template>
          <template v-else-if="value.type === 2">
            <!-- 判断题 -->
            <yxtf-radio-group v-model="value.submitContent"
                              :disabled="!!value.isAnswered ? 'lock': false"
                              :direction="'row'"
                              class="mfl12 mv-f8 color-primary-6 yxtbiz-practice__radio-group active"
                              @change="submitSingle()">
              <yxtf-radio :key="value.id + '1'"
                          :class="{'hover-primary-6-i': !value.isAnswered}"
                          class="yxtbiz-practice__radio active" label="1">{{value.judgeCorrectOptionContent || $t('pc_biz_ote_lbl_wright')}}</yxtf-radio>
              <yxtf-radio :key="value.id + '0'"
                          :class="{'hover-primary-6-i': !value.isAnswered}"
                          class="yxtbiz-practice__radio active" label="0">{{value.judgeWrongOptionContent || $t('pc_biz_ote_lbl_wrong')}}</yxtf-radio>
            </yxtf-radio-group>
          </template>
          <template v-else-if="value.type === 3">
            <!-- 填空题 -->
            <div v-for="(i, j) in value.fillInItems"
                 :key="i.id"
                 :class="{'mt20': j > 0,'mt16': j === 0}"
                 class="lh40 font-size-14 yxtbiz-practice__form">
              <div class="yxtbiz-practice__form-sub">
                {{ j + 1 }}.
              </div>
              <div class="yxtbiz-practice__form-content pl10">
                <yxtf-input v-model="i.submitAnswer"
                            class="yxtbiz-practice__form-input"
                            :disabled="!!value.isAnswered"
                            maxlength="500"
                            @change="submitSingle()"></yxtf-input>
              </div>
            </div>
          </template>
          <template v-else-if="value.type === 4">
            <!-- 问答题 -->
            <!-- 问答题答案最多输入2000字 -->
            <yxtf-input v-model="value.submitContent"
                        :disabled="!!value.isAnswered"
                        class="yxtbiz-practice__form-textarea"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 8}"
                        maxlength="2000"
                        show-word-limit
                        @change="submitSingle()">
            </yxtf-input>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import MediaPlayer from './media-player';
import { convertASCIIForNum, cleanStyle } from './common';
export default {
  name: 'UserPraQuesDetail',
  components: {
    MediaPlayer
  },
  props: {
    // 试题信息
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 题序
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    };
  },
  computed: {
    playerOptions() {
      if (this.value.tranStatus === 2) {
        const options = this.value.playDetails;
        return options.map(option => {
          return {
            fileFullUrl: option.url,
            fileId: this.value.fileId,
            resolution: option.desc
          };
        });
      }
      return [{
        fileFullUrl: '',
        label: ''
      }];
    }
  },
  watch: {
    'value.fillInItems': {
      handler(val) {
        this.$emit('submitSingle', this.value);
      },
      immediate: true,
      deep: true
    },
    'value.submitAnswer': {
      handler(val) {
        this.$emit('submitSingle', this.value);
      }
    },
    'value.submitContent': {
      handler(val) {
        this.$emit('submitSingle', this.value);
      }
    }
  },
  created() {
  },
  methods: {
    cleanStyle,
    convertASCIIForNum,
    submitSingle() {
      this.$emit('submitSingle', this.value);
    },
    playerMediaOptions(mediaPlay) {
      if (mediaPlay.tranStatus === 2) {
        const options = mediaPlay.playDetails;
        return options.map(option => {
          return {
            fileFullUrl: option.url,
            fileId: mediaPlay.fileId,
            resolution: option.desc
          };
        });
      }
      return [{
        fileFullUrl: '',
        label: ''
      }];
    }
  }
};
</script>
